import { atom } from "jotai";
import { calculateSidebarWidth } from "../utils/calculateSidebarWidth";
import { sideBarSelectedAtom, sideBarWidthAtom } from "./sideBarSelectedAtom";

/**
 * Adjusts sidebar width when copilot opens or closes.
 * Considers both copilot state and other sidebar states.
 *
 * See sideBarSelectedAtom for similar logic for other sidebar states.
 */
export const adjustSidebarWidthOnCopilotSetter = atom(
  null,
  (get, set, isCopilotOpen: boolean) => {
    const sideBarSelected = get(sideBarSelectedAtom);

    if (isCopilotOpen) {
      set(sideBarWidthAtom, calculateSidebarWidth(true));
    } else if (!sideBarSelected) {
      set(sideBarWidthAtom, calculateSidebarWidth(false));
    }
  },
);

adjustSidebarWidthOnCopilotSetter.debugLabel =
  "adjustSidebarWidthOnCopilotSetter";
